<template>
  <div class="form-group">
    <label
      :class="'control-label col-sm-' + labelWidth"
      :for="id"
      v-safe-html="label"
    />
    <div :class="'col-sm-' + (12 - labelWidth) + (hasErrorMessage ? ' has-error' : '')">
      <select
        :id="id"
        class="form-control"
        :name="name"
        :value="value"
        :disabled="disabled"
        @input="$emit('input', $event.target.value)"
      >
        <option
          v-if="hasDisabledMessage"
          disabled
          :value="''"
        >
          {{ disabled_message }}
        </option>

        <option
          v-for="(display_value, key) in option_object"
          :value="key"
        >
          {{ display_value }}
        </option>
      </select>

      <span
        v-if="hasErrorMessage"
        class="help-block"
      >
        <strong>{{ errormessage }}</strong>
      </span>
    </div>
  </div>
</template>

<script>
// todo: make the first option the default option if there is no disabledmessage
export default {
  name: 'SelectorComponent',
  props: {
    id: {
      required: true,
    },
    label: {
      required: true,
    },
    name: {
      default: 'name',
    },
    options: {
      required: true,
      type: [Array, Object],
    },
    errormessage: {
      default: null,
    },
    value: '',
    disabled_message: {
      default: null,
    },
    labelWidth: {
      default: 2,
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data () {
    return {
      option_object: {},
    }
  },
  computed: {
    hasErrorMessage () {
      return this.errormessage !== null
    },
    hasDisabledMessage () {
      return this.disabled_message !== null
    },
  },
  watch: {
    options: function () {
      this.option_object = this.options
    },
  },
  beforeMount () {
    // has to happen before mount, otherwise the first item is selected, but the event is not emitted
    // so it looks like it is selected, but in reality it is not
    if (Array.isArray(this.options)) {
      this.option_object = this.options.reduce((option_obj, val, i) => {
        // accumulate all values into the object
        option_obj[val] = val

        return option_obj
      }, {})
    } else {
      this.option_object = this.options
    }
  },
}
</script>

<style scoped>

</style>
